import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Box,
  styled,
  Button,
  Menu,
  MenuItem,
  Grid2,
  ButtonGroup,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SortBySelectorButton = styled(Button)({
  fontSize: "12px",
  color: "#3D4B5A",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "none",
  minWidth: "auto",
  borderRadius: "8px",
  border: "1px solid #E6E6E6",
  borderLeft: 'none',
  borderColor: "#E6E6E6",
  padding: "8px 14px",
  backgroundColor: "#FFFFFF",

  "& .MuiButton-endIcon": {
    "& .MuiSvgIcon-root": {
      color: "#2E2E2E",
      fontSize: "15px !important",
    },
  },
});

const DropdownMenu = styled(Menu)({
  "& .MuiPaper-root": {
    width: "auto",
    minWidth: "120px",
    padding: "0 8px",
    borderRadius: "10px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px 0px #C0C0C052",
  },
});

const ColumnMenuItem = styled(MenuItem)({
  padding: "4px 8px",
  fontWeight: 400,
  fontSize: "12px",
  color: "#3D4B5A",
  backgroundColor: "#FFFFFF",
  borderRadius: "8px",
  lineHeight: "24px",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    fontWeight: 500,
    color: "#6D72F6",
    backgroundColor: "#F4F5FF",
  },
});

const SORT_BY_COLUMNS = [
  { key: "batteriesBySeverity", label: "Severity", order: 'desc' },
  { key: "customerDBTimeInsert", label: "Date - Oldest to Newest", order: 'asc' },
  { key: "customerDBTimeInsert", label: "Date - Newest to Oldest", order: 'desc' },
]

const AlertListSortBySelection = ({ onSortChange, defaultSort }) => {
  const [dropdownAnchorElement, setDropdownAnchorElement] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(SORT_BY_COLUMNS[0]);

  const openColumnDropdown = useCallback((event) => {
    setDropdownAnchorElement(event.currentTarget);
  }, []);

  const closeColumnDropdown = useCallback(() => {
    setDropdownAnchorElement(null);
  }, []);

  const handleSortChange = (column) => {
    const sort = {
      ...selectedColumn,
      ...column,
    };
    setSelectedColumn(sort);
    closeColumnDropdown();
    onSortChange(sort);
  };

  useEffect(() => {
    if (defaultSort?.[0]) {
      const defaultSortItem = defaultSort[0];
      const defaultSortColumns = SORT_BY_COLUMNS.filter(column => column.key === defaultSortItem.sortBy && column.order === defaultSortItem.order) ?? [];
      setSelectedColumn(defaultSortColumns.length ? defaultSortColumns[0] : SORT_BY_COLUMNS[0])
    }
  }, [defaultSort])

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <ButtonGroup aria-label="Sort by group">
        <SortBySelectorButton
          onClick={openColumnDropdown}
          endIcon={<KeyboardArrowDownIcon />}
        >
          <Grid2 container alignItems={"center"} gap={1}>
            <Typography
              variant="fw400s12c3D4B5A"
              sx={{
                lineHeight: "16px",
                fontWeight: 500,
                color: "#2E2E2E",
              }}
            >
              Sort by: {selectedColumn?.label}
            </Typography>
          </Grid2>
        </SortBySelectorButton>
      </ButtonGroup>

      <DropdownMenu
        anchorEl={dropdownAnchorElement}
        open={Boolean(dropdownAnchorElement)}
        onClose={closeColumnDropdown}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {SORT_BY_COLUMNS.map((column) => (
          <ColumnMenuItem
            key={column.key}
            onClick={() => handleSortChange(column)}
          >
            {column.label}
          </ColumnMenuItem>
        ))}
      </DropdownMenu>
    </Box>
  );
};

export default AlertListSortBySelection;
